// Préférences d'affichage des listes (AdminTableSync), persistées en localStorage,
// par liste (clé = storeNamespace de la config). Ex. : panneau "Plus d'options"
// ouvert ou non sur /renting_preparation.

const STORAGE_KEY = 'tablePrefs'

function load() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}
  } catch (e) {
    return {}
  }
}

export default {
  namespaced: true,
  state: {
    prefs: load(),
  },
  getters: {
    // undefined = pas de préférence enregistrée pour cette liste
    extendedFiltersOpen: state => key => (key && state.prefs[key] ? state.prefs[key].extendedFiltersOpen : undefined),
  },
  mutations: {
    setExtendedFiltersOpen(state, { key, open }) {
      state.prefs = {
        ...state.prefs,
        [key]: { ...(state.prefs[key] || {}), extendedFiltersOpen: open },
      }
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state.prefs))
    },
  },
  actions: {
    setExtendedFiltersOpen({ commit }, payload) {
      commit('setExtendedFiltersOpen', payload)
    },
  },
}



// WEBPACK FOOTER //
// ./src/stores/modules/table_pref.js